import * as React from "react";
import { Switch, Radio, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";

interface SwitcherItemProps {
  onChange: () => void;
  onStartsWithChange: () => void;
  showStartWith: boolean;
  defaultChecked: boolean;
  pickedAsStartWith: boolean;
  icon: IconName | React.ReactNode;
  name: string;
  description: string;
  checked: boolean;
}

export const SwitcherItem: React.FC<SwitcherItemProps> = ({
  checked,
  onChange,
  onStartsWithChange,
  showStartWith,
  pickedAsStartWith,
  defaultChecked,
  icon,
  name,
  description,
}) => {
  return (
    <h5>
      <Switch onChange={onChange} defaultChecked={defaultChecked} disabled={pickedAsStartWith} checked={checked} />
      <div style={{ display: "inline-block", visibility: showStartWith ? "visible" : "hidden" }}>
        <Tooltip title={"Main module"}>
          <Radio
            className="ml-md"
            checked={pickedAsStartWith}
            disabled={!defaultChecked}
            onChange={onStartsWithChange}
          />
        </Tooltip>
      </div>
      {typeof icon === "string" ? (
        <FontAwesomeIcon style={{ margin: `0 5px` }} icon={icon as IconName} size="lg" fixedWidth={true} />
      ) : (
        icon
      )}
      {name}
      {description && <span style={{ fontSize: 11 }}> ({description})</span>}
    </h5>
  );
};
